<app-page-header routerLink="/" origin="Home" title="Scholen" [showAddButton]="true"
  (buttonClicked)="openModal(null)"></app-page-header>

<app-table-guru [apiEndpoint]="'/office/organisations'" [defaultFilters]="[{ key: 'type', value: 'VO' }]"
  [enableFilters]="true" 
  [columnMapping]="[
        { key: 'name', label: 'Naam' },
        { key: 'authority_number', label: 'BGN' },
        { key: 'region', label: 'Regio', cssClass: 'text-capitalize' },
        { key: 'type', label: 'Type', cssClass: 'text-uppercase' },
       
        { key: 'department_number', label: 'Vestigingscode' },
        { key: 'city', label: 'Plaats' },

        { key: 'extend_intention', label: 'Verlengen', type: 'boolYesNo' },
        { key: 'active', label: 'Actief', type: 'boolYesNo' }
      ]" [itemsPerPage]="10" [viewURL]="'/school/details/'" [openModalComponent]="editFormReference"
  [reload]="reloadItems">
</app-table-guru>